<!-- eslint-disable vue/camelcase -->
<script>
import Layout from '@layouts/main.vue'
import CandidateList from '@components/message/candidate-list.vue'
import MessageContainer from '@components/message/message-container.vue'
import { mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import messageMixin from '@/mixins/messageMixin'

export default {
  name: 'MessageView',
  components: {
    Layout,
    CandidateList,
    MessageContainer,
  },
  mixins: [baseMixin, messageMixin],
  data() {
    return {
      selectedId: null,
    }
  },
  metaInfo: {
    title: 'Messaging',
    meta: [{ name: 'description', content: 'The Messaging page.' }],
  },
  async created() {
    await this.handleQueryArgs()
  },
  async beforeDestroy() {
    await this.setCurrentlyViewedCandidateMessages(null)
  },
  methods: {
    ...mapActions({
      setCurrentlyViewedCandidateMessages:
        'message/setCurrentlyViewedCandidateMessages',
    }),
    async loadMessagesFromQueryArg() {
      if (this.messagesQueryCandidateId)
        await this.loadMessages(parseInt(this.messagesQueryCandidateId))
      else if (this.messagesQueryContactId)
        throw new Error('Contact messages have not been implemented yet')
    },
    async handleQueryArgs() {
      await this.loadMessagesFromQueryArg()
    },
    async loadMessages(id) {
      // Ensure message container is destroyed before loading new messages
      this.selectedId = null
      await this.setCurrentlyViewedCandidateMessages(null)
      await this.$nextTick

      if (!id) return

      await this.setCurrentlyViewedCandidateMessages(id)
      this.selectedId = id
    },
  },
}
</script>

<template>
  <Layout class="fill-height" no-gutters>
    <v-row no-gutters class="fill-height">
      <v-col v-if="messagesShowCandidateList" cols="12" md="3">
        <CandidateList
          @clear-reading-pane="loadMessages(null)"
          @load-messages="loadMessages"
        />
      </v-col>
      <v-col
        v-if="selectedId"
        cols="12"
        :md="messagesShowCandidateList ? 9 : 12"
      >
        <MessageContainer :contact-id="selectedId" />
      </v-col>
    </v-row>
  </Layout>
</template>
